import { ABIInput, AbiInputProps } from '@ab-inbev-labs/ux-react-components';
import React, { FC } from 'react';

// Wrapper around ABIInput to set border and label props by default
export const Input: FC<AbiInputProps> = (props) => {
  return <ABIInput isBorderLight withoutFloatingLabel {...props} />;
};
